module.exports = __webpack_public_path__ + "static/media/logo.698f34ea.png";